import { Action, ActionReducer, createFeature, createReducer, on } from '@ngrx/store';

import * as PriceAndAvailabiltyActions from './price-and-availability.actions';
import { initialState, PriceAndAvailabilityState } from './price-and-availability.state';

export const priceAndAvailabilityReducer: ActionReducer<
  PriceAndAvailabilityState,
  Action<string>
> = createReducer(
  initialState,

  on(
    PriceAndAvailabiltyActions.loadPriceAndAvailability,
    (state): PriceAndAvailabilityState => ({
      ...state,
      loading: true,
      error: null,
    })
  ),

  on(
    PriceAndAvailabiltyActions.loadPriceAndAvailabilitySuccess,
    (state, { priceAndAvailabilityResponse }): PriceAndAvailabilityState => ({
      ...state,
      priceAndAvailability: priceAndAvailabilityResponse.data,
      totalCount: priceAndAvailabilityResponse.totalCount,
      currentPage: priceAndAvailabilityResponse.pageNumber,
      pageSize: priceAndAvailabilityResponse.pageSize,
      loading: false,
    })
  ),

  on(
    PriceAndAvailabiltyActions.loadPriceAndAvailabilityFailure,
    (state, { error }): PriceAndAvailabilityState => ({
      ...state,
      loading: false,
      error,
    })
  ),

  on(
    PriceAndAvailabiltyActions.setSearchTerm,
    (state, { searchTerm }): PriceAndAvailabilityState => ({
      ...state,
      filters: {
        ...state.filters,
        searchTerm,
      },
      currentPage: 1,
    })
  ),

  on(
    PriceAndAvailabiltyActions.setCountryFilter,
    (state, { countries }): PriceAndAvailabilityState => ({
      ...state,
      filters: {
        ...state.filters,
        selectedCountries: countries,
      },
      currentPage: 1,
    })
  ),

  on(
    PriceAndAvailabiltyActions.setLicenseFilter,
    (state, { isEma, isNational }): PriceAndAvailabilityState => ({
      ...state,
      filters: {
        ...state.filters,
        isEma,
        isNational,
      },
    })
  ),

  on(
    PriceAndAvailabiltyActions.setPage,
    (state, { pageNumber }): PriceAndAvailabilityState => ({
      ...state,
      currentPage: pageNumber,
    })
  ),

  on(
    PriceAndAvailabiltyActions.setPageSize,
    (state, { pageSize }): PriceAndAvailabilityState => ({
      ...state,
      pageSize: pageSize,
      currentPage: 1,
    })
  ),

  on(
    PriceAndAvailabiltyActions.setSorting,
    (state, { sortBy, isSortAsc }): PriceAndAvailabilityState => ({
      ...state,
      sortBy,
      isSortAsc,
      currentPage: 1,
    })
  ),

  on(
    PriceAndAvailabiltyActions.clearFilters,
    (state): PriceAndAvailabilityState => ({
      ...state,
      filters: {
        searchTerm: '',
        selectedCountries: [],
        isEma: false,
        isNational: false,
      },
    })
  )
);

export const priceAndAvailabilityFeature: ReturnType<
  typeof createFeature<string, PriceAndAvailabilityState>
> = createFeature({
  name: 'priceAndAvailability',
  reducer: priceAndAvailabilityReducer,
});
